import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Router, Switch, Route, RouteProps } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import configureStore, { history } from 'store';
import { ROUTES } from 'routes';
import ScrollToTop from 'ScrollToTop';
import { ThemeProvider } from '@material-ui/styles';
//import toasters native style
import 'react-toastify/dist/ReactToastify.min.css';

import LanguageProvider from 'containers/LanguageProvider/index';
import CorporealTheme from 'constants/theme';
import CssBaseline from '@material-ui/core/CssBaseline';
import GATracking from 'components/GATracking/index';
import Toaster from 'components/Toasters/index';
import fflip from 'fflip';
import fflipConfig from 'features/fflip-config';
import { StylesProvider } from '@material-ui/core/styles';

const store = configureStore();

const App: React.FC = (): JSX.Element => {
  useEffect(() => {
    GATracking.init();
    GATracking.pageView();
    fflip.config(fflipConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StylesProvider injectFirst>
      <Provider store={store}>
        <ThemeProvider theme={CorporealTheme}>
          <CssBaseline />
          <LanguageProvider>
            <Router history={history}>
              <LastLocationProvider>
                <ScrollToTop>
                  <Toaster />
                  <Switch>
                    {ROUTES.map((props: RouteProps, idx: number) => (
                      <Route key={idx} {...props} />
                    ))}
                  </Switch>
                </ScrollToTop>
              </LastLocationProvider>
            </Router>
          </LanguageProvider>
        </ThemeProvider>
      </Provider>
    </StylesProvider>
  );
};

export default App;
